// The Build proof sheet's Key proof stars (`_refund_key_proof_star.html`, at the end of each
// call, file, text and email row in `_refund_claim_proof_build_sheet.html`).  Starring a row
// posts its `key_item`, shows its "What it shows" caption (a file keeps its own caption), and
// checks it; unchecking a starred row unstars it.  The sheet's empty state shows while nothing
// is starred.  A row that does not count for the claim's reason also shows its
// `data-key-proof-note` ("Starred for ...") only while starred.
function setStar(row, on) {
    const star = row.querySelector('[data-key-proof-star]');
    star.classList.toggle('active', on);
    star.setAttribute('aria-pressed', on);
    star.querySelector('i').className = `fa-${on ? 'solid' : 'regular'} fa-star`;
    row.querySelector('[data-key-proof-value]').disabled = !on;
    const caption = row.querySelector('[data-key-proof-caption]');
    if (caption) caption.hidden = !on;
    // "Starred for ...", on a row that does not count for the reason, is only true while starred.
    const note = row.querySelector('[data-key-proof-note]');
    if (note) note.hidden = !on;
    const checkbox = row.querySelector('.form-check-input');
    if (on && !checkbox.checked) {
        // Through `change`, the path a manual check takes.
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const form = row.closest('form');
    form.querySelector('[data-key-proof-empty]').hidden = !!form.querySelector('[data-key-proof-star].active');
}

// A button inside the row's <label> does not toggle the row's checkbox.
document.addEventListener('click', function (event) {
    const star = event.target.closest('[data-key-proof-star]');
    if (!star) return;
    const row = star.closest('.list-group-item');
    const on = !star.classList.contains('active');
    setStar(row, on);
    if (on) row.querySelector('input[type="text"]:not([hidden])').focus();
});

document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input.matches('.form-check-input') || input.checked) return;
    const row = input.closest('.list-group-item');
    if (row && row.querySelector('[data-key-proof-star].active')) setStar(row, false);
});
